
<div class="d-flex align-items-center">
    <div class="expanding-button mx-2 d-flex align-items-center">
        <fa-icon [icon]="iconService.faIconsSolid.faHistory"></fa-icon>
        <div class="label ms-2">History</div>
    </div>
    <input (ngModelChange)="searchKeyPressed($event)"
           (focusout)="setSearchActive(false)"
           (keydown.enter)="enterPressed($event)"
           [(ngModel)]="searchText"
           class="input input-round search glass-light" placeholder="Search" />
    <div class="toolbar d-flex align-items-center ms-3">
            <div class="profile pointer" (click)="setProfileActive()">
                <profile-image></profile-image>
            </div>
    </div>
</div>
